import React from 'react'
import { fnColorStatus } from '../../helper/fnColorStatus'

export default function BageStatusCustom({ id, name = '', className = '' }) {
  return (
    <span
      className={`fw-light ${className}`}
      style={{
        color: fnColorStatus(id).color,
        backgroundColor: fnColorStatus(id).bg,
        padding: '2px 8px 2px 8px',
        borderRadius: '2rem',
        fontSize: '12px'
      }}
    >
      {name}
    </span>
  )
}
